import React, { Fragment, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { MdOutlineEditCalendar } from "react-icons/md";
import { useSelector } from "react-redux";
import { Set } from "../../../Request";
import { webTemp } from "../../../Utils/styles";
import AuthModal from "../../View/Auth/AuthModal";
import { renderTimeMonth } from "../Function";
import CustomModal from "../Modal/CustomModal";
import StarRating from "../Rate/StarRating";

const Commonets = ({ id, rel, comments, showRegisterComment, showCommentList, isApp }) => {
  const initialState = {
    loading: false,
    data: {
      text: null,
      rel_id: id,
      score: 5,
      rel_type: rel,
    },
  };
  useEffect(() => {
    setState(initialState);
  }, []);

  const [state, setState] = useState(initialState);
  const [loadingBtn, setloadingBtn] = useState(false);
  const [modal, setModal] = useState(false);
  const { user, user_type } = useSelector(state => state);
  const [showModalLogin, setShowModalLogin] = useState(false);

  const renderImg = () => {
    if (user && user.profile && user.profile[0]) {
      return user.profile[0];
    } else {
      return window.origin + "/WebSide/assets/images/userimage.png";
    }
  };
  const StoreComment = async data => {
    return await Set({
      url: "/comment/create",
      data: {
        ...data,
      },
    }).then(data => {
      return data;
    });
  };

  const Commenthandler = data => {
    setState({ ...state, loading: true });
    setloadingBtn(true);
    StoreComment(data).then(() => {
      setState({
        ...state,
        loading: false,
      });
      setloadingBtn(false);
    });
  };
  const renderData = data => {
    switch (data.rel_type) {
      case "admin":
        return {
          text: "پشتیبان",
          right: true,
          status: false,
          label: null,
          img: window.origin + "/WebSide/assets/images/nikotancomment.png",
        };
        break;
      case "manager":
        return {
          text: "مدیریت مجموعه",
          right: false,
          status: "active",
          label: <span className="badge bg-success">فعال</span>,
          img: window.origin + "/WebSide/assets/images/unkhnowuser.png",
        };

      case "user":
        return {
          text: data.comenter.fullname,
          right: false,
          status: "active",
          label: <span className="badge bg-success">فعال</span>,
          img: data.comenter.profile[0],
        };

      default:
        break;
    }
  };
  return (
    <>
      {registerComment(user, user_type, showRegisterComment, renderImg(), setModal, showModalLogin, setShowModalLogin, isApp)}

      {commentList(comments, showCommentList, setModal, renderData, modal, Commenthandler, loadingBtn, id, rel, isApp)}
    </>
  );
};

export default Commonets;

const registerComment = (user, user_type, showRegisterComment, renderImg, setModal, showModalLogin, setShowModalLogin, isApp) => {

  if (showRegisterComment == undefined || showRegisterComment == true) {
    return (
      <Fragment>
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <div className="d-flex  align-items-center">
            <img
              src={renderImg}
              alt={(user && user.fullname) || "عکس کاربر"}
              style={{ width: "30px", height: "30px", borderRadius: "15px" }}
            />
            <h6
              style={{
                margin: "0",
                marginRight: "10px",
                fontWeight: "400",
              }}
            >
              {user && user.fullname}
            </h6>
          </div>
          <div className={isApp && "mr-auto"}>
            <button
              className={isApp ? "btn btn-primary w-100" : "btn btn-orange px-5 py-2 ms-3"}
              onClick={() => {
                if (user_type == null) {
                  toast.error("برای ثبت نظر ابتدا باید ثبت نام کنید");
                  setShowModalLogin(true)
                } else {
                  setModal("u");
                }
              }}
            >
              ثبت نظر
            </button>
          </div>
        </div>
        <AuthModal show={showModalLogin} setShow={setShowModalLogin} />

      </Fragment>
    )
  }
  else {
    return <></>
  }
}

const commentList = (comments, showCommentList, setModal, renderData, modal, Commenthandler, loadingBtn, id, rel, isApp) => {
  if (showCommentList == undefined || showCommentList == true) {
    return (
      <div className={isApp && "border-top mt-3"}>
        {comments?.data?.length === 0 ? (
          <p
            className="h6 text-center mt-5"
            style={{
              fontWeight: "400",
            }}
          >
            نظری برای این مجموعه ثبت نشده است !
          </p>
        ) : (
          comments.data.map((item, i) => {
            return (
              <Fragment key={i}>
                <div className={"comentbox " + (isApp ? "border shadow-none py-2" : "border-0")}
                  style={{ ...webTemp, boxShadow: "0px 0px 7px 0px #0000001c", padding: " 15px 20px" }}>
                  <div className={"right-side d-flex border-bottom " + (isApp && "align-items-center")}
                    style={{
                      paddingBottom: "10px",
                    }}
                  >
                    <img
                      src={
                        window.origin + "/WebSide/assets/images/comment.png"
                      }
                      alt="nikotan | نیکوتن"
                      className="rounded-circle"
                      height={30}
                      width={30}
                    />
                    <div className={"d-flex ms-3 flex-fill " + (isApp && "flex-column")} style={{ marginRight: "10px" }}>
                      <p
                        style={{
                          color: "#404040",
                          fontSize: "15px",
                          fontWeight: "400",
                        }}
                      >
                        {item.comenter && item.comenter.fullname}
                      </p>
                      <p className={isApp ? "mt-1" : "ms-auto me-2"}
                        style={{
                          fontSize: "12px",
                          color: "#929292",
                          fontWeight: "400",
                        }}
                      >
                        <MdOutlineEditCalendar className="me-2" size={"19px"} />
                        {renderTimeMonth(item.created_at)}
                      </p>
                    </div>
                  </div>
                  <div className={"left-side " + (isApp && "mt-2")}>
                    {/* <div>
                      <RateRender
                          data={item.score}
                          styles={{ display: "flex", justifyContent: "right" }}
                        />
                    </div> */}
                    <div>
                      <p
                        style={{
                          fontSize: "13px",
                          marginRight: "15px",
                          marginTop: "10px",
                          color: "#000",
                          textAlign: "justify",
                          fontWeight: "400",
                        }}
                      >
                        {item.text}
                      </p>
                    </div>
                    {item.replies &&
                      item.replies.map((reply, key) => {
                        return (
                          <div
                            className="row justify-content-end mt-3"
                            key={key}
                          >
                            {isApp &&
                              <span style={{
                                display: "flex",
                                width: "1px",
                                height: "20px",
                                background: "#c7c7c7",
                                marginLeft: "auto",
                                marginRight: "25px"
                              }}></span>
                            }
                            <div className="comentbox-rep col-md-11">
                              <div className="right-side-rep d-flex align-items-center">
                                <img
                                  src={renderData(reply)["img"]}
                                  alt="nikotan | نیکوتن"
                                  className=""
                                  height={30}
                                />
                                <div style={{ marginRight: "10px" }}>
                                  {" "}
                                  <p
                                    className="name-comenter"
                                    style={{
                                      color: "#000",
                                    }}
                                  >
                                    {renderData(reply)["text"]}
                                  </p>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      color: "#929292",
                                    }}
                                  >
                                    {renderTimeMonth(item.created_at)}
                                  </p>
                                </div>
                              </div>
                              <div className="left-side-rep">
                                <div>
                                  <p
                                    style={{
                                      fontSize: "13px",

                                      color: "#929292",
                                      textAlign: "justify",
                                    }}
                                  >
                                    {reply.message}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </Fragment>
            );
          })
        )}
        {comments.data.length > 10 ? (
          <div className="see-more d-flex justify-content-center">
            <a href="#" className="btn shadow-sm border rounded-15 py-2 px-5">
              مشاهده موارد بیشتر
            </a>
          </div>
        ) : null}

        <CustomModal
          show={modal}
          size="md"
          header={"افزودن دیدگاه"}
          handleClose={() => setModal(false)}
        >
          <AddComment
            id={id}
            type={modal}
            Commenthandler={Commenthandler}
            loadingBtn={loadingBtn}
            rel={rel}
            isApp={isApp}
          />
        </CustomModal>
      </div>
    )
  }
  else {
    return <>
      <CustomModal
        show={modal}
        size="md"
        header={"افزودن دیدگاه"}
        handleClose={() => setModal(false)}
      >
        <AddComment
          id={id}
          type={modal}
          Commenthandler={Commenthandler}
          loadingBtn={loadingBtn}
          rel={rel}
        />
      </CustomModal>
    </>
  }
}

const AddComment = ({ type, Commenthandler, loadingBtn, rel, id, isApp }) => {
  const [state, setState] = useState({
    rel_type: rel,
    rel_id: id,
  });

  return (
    <div className="">
      <form className=" rounded-15 p-2 ">
        <div className="row md-margin-need">
          <div className="col mb-2">
            <textarea
              rows={6}
              type="text"
              className="form-control"
              placeholder="نظر شما ..."
              onChange={e => {
                setState({
                  ...state,
                  text: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <StarRating
          setState={setState}
          state={state}
          style={{ flex: 1, marginBottom: "20px", flexDirection: "column", padding: "0px 10px" }}
          end={true}
          text={"امتیاز"}
        />
        <div className="row mt-md-2 d-flex mx-1 md-margin-need justify-content-end">
          {/* <div className="col-md-4"> */}
          <button
            type="button"
            className={isApp ? "btn btn-primary w-100" : "btn btn-orange"}
            onClick={() => Commenthandler(state)}
            disabled={loadingBtn}
            style={{
              fontSize: "16px",
            }}
          >
            {loadingBtn ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "ارسال نظر"
            )}
          </button>
          {/* </div> */}
        </div>
      </form>
    </div>
  );
};